import {Vue} from 'ui.vue';

export let CatalogSectionSwiper = {
	name: 'CatalogSectionSwiper',
	store: BX.Citrus.Vuex.store,
	data: function () {
		return {
			settings:{
				title: '',
				url: '',
				sliderHasBtn: true,
			},
			slider: null,
			products: [],
			swiperOption: {
				slidesPerView: 1,
				spaceBetween: 20,
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					1023: {
						slidesPerColumn: 1,
						slidesPerView: 1,
						spaceBetween: 0,
					},
				}
			},
			loading: false,
			storage: 'vuex',
		};
	},
	mixins: [BX.Citrus.Vue.Component.BulletsRestClient],
	mounted () {
		this.slider = new Swiper(this.$refs.productsSwiper, this.swiperOption);
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("TPL_CATALOG_SECTION_");
		},
		isViewStock() {
			return this.$store.getters['basket/isViewStock'];
		}
	},
	created: function() {
		this.resetSwiperOption();
		this.getBulletsInfo(this.products, this.bulletsProperty);
	},
	methods: {
		redrawSwiper: function() {
			this.resetSwiperOption();
			if (this.$refs.hasOwnProperty('productsSwiper'))
			{
				this.$refs.productsSwiper.swiper.destroy();
				this.$refs.productsSwiper.mountInstance();
				this.$refs.productsSwiper.update();
			}
		},
		resetSwiperOption: function() {
			this.swiperOption.navigation.nextEl = this.$options.el + " .swiper-button-next";
			this.swiperOption.navigation.prevEl = this.$options.el + " .swiper-button-prev";
			this.swiperOption.pagination.el = this.$options.el + " .swiper-pagination";

			if (this.settings.sliderHasBtn) {
				this.swiperOption.watchOverflow = true;
			}
			else {
				var breakpoints = 1024;
				if (window.innerWidth < breakpoints) {
					this.swiperOption.slidesPerColumn = 1;
					this.swiperOption.slidesPerView = 1;
					this.swiperOption.spaceBetween = 0;
					this.swiperOption.breakpoints = {};
				} else {
					if (this.products.length < 9 ) {
						this.swiperOption.slidesPerColumn = 1;
					}
					else {
						this.swiperOption.slidesPerColumn = 2;
					}

					this.swiperOption.slidesPerView = 5;
					this.swiperOption.spaceBetween = 20;
					this.swiperOption.breakpoints = {
						1023: {
							slidesPerColumn: 1,
							slidesPerView: 1,
							spaceBetween: 0,
						},
						1365: {
							slidesPerView: 4,
						}
					};
				}
			}
		},
	},
};

export default {CatalogSectionSwiper};
